import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8l4 8","key":"svg-0"}],["path",{"d":"M10 16l4 -8","key":"svg-1"}]]

const IconLetterXSmall = createReactComponent('outline', 'letter-x-small', 'LetterXSmall', __iconNode);

export default IconLetterXSmall;